import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SynSplashScreenComponent } from './@components';
import { ProjectorHeartbeatService } from './@services/projector-heartbeat.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, SynSplashScreenComponent],
})
export class AppComponent {
  constructor() {
    // SYN-2534: if this app instance is a projector window opened by the
    // admin dashboard, start announcing liveness so the dashboard can keep
    // CV's projection status correct across a dashboard refresh. No-op on
    // the normal audience view.
    inject(ProjectorHeartbeatService).start();
  }
}
